var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol, BOverlay, BPagination } from 'bootstrap-vue';
import axios from 'axios';
import FrameResult from 'components/standard-size-picture-frames/FrameResult.vue';
import { getApertureDimensions } from 'ts/modules/frameDesigner';
import { DesignerStorage } from 'ts/modules/designerStorage';
let FrameResults = class FrameResults extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.currentPage = 1;
        this.rows = 0;
        this.perPage = 24;
        this.results = [];
        this.defaultGlazing = null;
    }
    get rebateSize() {
        return {
            width: this.artworkSize.width - 6 + (this.filter.mountType == 'single' ? (this.filter.mountWidth * 2) : 0) + 3,
            length: this.artworkSize.length - 6 + (this.filter.mountType == 'single' ? (this.filter.mountWidth * 2) : 0) + 3
        };
    }
    get apertureSize() {
        return getApertureDimensions(this.artworkSize);
    }
    loadDesigner(moulding) {
        let frame = {
            size: this.artworkSize,
            moulding,
            mount: {
                type: this.filter.mountType,
                top: this.filter.mountColour,
                bottom: null,
                borders: {
                    top: this.filter.mountWidth,
                    bottom: this.filter.mountWidth,
                    left: this.filter.mountWidth,
                    right: this.filter.mountWidth
                },
                reveal: 3
            },
            glazing: this.defaultGlazing,
            extras: {
                backing: true,
                fixings: true,
                undermount: false,
                fastmount: false,
                spacer: false
            },
            imageName: null
        };
        // Save the designer options
        let storage = new DesignerStorage();
        storage.save(frame);
        // Redirect to the designer
        location.href = '/picture-frames/design?quickCheckout=1';
    }
    get queryParams() {
        var _a;
        return {
            artworkLength: this.artworkSize.length,
            artworkWidth: this.artworkSize.width,
            where: {
                minWidth: this.filter.widthRange[0],
                maxWidth: this.filter.widthRange[1],
                colourID: this.filter.colourId,
                styleRating: this.filter.styleRating
            },
            mountType: this.filter.mountType,
            mountWidth: this.filter.mountWidth,
            mountSku: `MCTS-${((_a = this.filter.mountColour) === null || _a === void 0 ? void 0 : _a.stock_lookup_sku) || '8001'}`,
            orderBy: this.filter.sortBy,
            sortDir: this.filter.order,
            page: this.currentPage
        };
    }
    search() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            this.results = [];
            let { data } = yield axios.get('/api/standardSizePictureFrames/suitableFrames', { params: this.queryParams });
            this.results = data.data;
            this.rows = data.total;
            this.loading = false;
            if (this.currentPage > 1) {
                // Scroll to top of results
                (_a = document.getElementById('FrameFilters')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    }
    mounted() {
        this.search();
        // Get the 2mm acrylic item
        axios
            .get('/api/materials/sheets/bySku', {
            params: {
                sku: 'AG-2'
            }
        })
            .then(({ data }) => this.defaultGlazing = data);
    }
};
__decorate([
    Prop(Object)
], FrameResults.prototype, "filter", void 0);
__decorate([
    Prop(Object)
], FrameResults.prototype, "artworkSize", void 0);
__decorate([
    Watch('filter', { deep: true }),
    Watch('currentPage')
], FrameResults.prototype, "search", null);
FrameResults = __decorate([
    Component({
        components: {
            BRow, BCol, BOverlay, BPagination,
            FrameResult
        }
    })
], FrameResults);
export default FrameResults;
